import { EntryContentTypeFieldsEnum } from '@seuk/cms-api-client';
import { LOCALES } from '@seuk/shared-data';

import { getCMSClient } from '../../services/cms';

export const toDashed = (str: string) => {
  return str.toLowerCase().replaceAll(' ', '-');
};

export const getEntries = async () => {
  return (
    await Promise.all(
      LOCALES.map((locale) =>
        getCMSClient().getAllEntries({ contentType: EntryContentTypeFieldsEnum.PageHelp, query: { locale } })
      )
    )
  ).flat();
};
